import React, { useEffect, useState } from 'react';
import { X, Loader2 } from 'lucide-react';

import useDrive from '../../hooks/useDrive';
import { useViewDocument } from '../../../UploadDocuments/hooks/Useuploaddocuments';

import PreviewHeader from './PreviewHeader';
import PreviewBody from './PreviewBody';

import { Overlay, Drawer, CloseButton } from './Preview.styles';

const PreviewDrawer = () => {
  const { previewOpen, previewFile, setPreviewOpen, setPreviewFile, applicationId } = useDrive();
  const [previewUrl, setPreviewUrl] = useState('');

  const { mutate: viewDoc, isPending } = useViewDocument({
    onSuccess: (data) => {
      setPreviewUrl(data?.documentUrl ?? data?.url ?? '');
    },
    onError: () => {
      setPreviewUrl('');
    },
  });

  useEffect(() => {
    if (previewOpen && previewFile?.documentId && !previewFile.url) {
      setPreviewUrl('');
      viewDoc({ documentId: previewFile.documentId, applicationId });
    }
    if (!previewOpen) setPreviewUrl('');
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [previewOpen, previewFile?.documentId]);

  const handleClose = () => {
    setPreviewOpen(false);
    setPreviewFile(null);
    setPreviewUrl('');
  };

  if (!previewOpen) return null;

  const fileWithUrl = previewFile ? { ...previewFile, url: previewFile.url || previewUrl } : null;

  return (
    <Overlay onClick={handleClose}>
      <Drawer onClick={(e) => e.stopPropagation()}>
        <CloseButton onClick={handleClose}>
          <X size={18} />
        </CloseButton>

        <PreviewHeader file={fileWithUrl} />

        {isPending && !fileWithUrl?.url ? (
          <div style={{ display: 'flex', justifyContent: 'center', padding: '2rem' }}>
            <Loader2 size={24} className="spin" />
          </div>
        ) : (
          <PreviewBody file={fileWithUrl} />
        )}
      </Drawer>
    </Overlay>
  );
};

export default PreviewDrawer;
